import selectCombatantResponseCollection from './selectCombatantResponseCollection'

//------------------------------
// sync loaded combatant row
//------------------------------
export default function syncLoadedCombatantRow(currentCombatant, refreshedStoreCombatant) {
  if (!refreshedStoreCombatant) {
    return currentCombatant
  }

  const syncedCombatant = {
    ...currentCombatant,
    ...refreshedStoreCombatant,
    actions: selectCombatantResponseCollection(
      refreshedStoreCombatant.actions,
      currentCombatant?.actions,
    ),
    markers: selectCombatantResponseCollection(
      refreshedStoreCombatant.markers,
      currentCombatant?.markers,
    ),
    reactions: selectCombatantResponseCollection(
      refreshedStoreCombatant.reactions,
      currentCombatant?.reactions,
    ),
  }

  Object.assign(refreshedStoreCombatant, syncedCombatant)

  return refreshedStoreCombatant
}
